import React, { useState } from 'react';
import AuthHeader from '@apps/components/AuthHeader';
import SignUpContainer from '@apps/containers/SignUpContainer';
import { Box, Link, Typography } from '@mui/material';
import SuccessLogo from '@stack/assets/images/success-logo.png';
import { PageType, SideCover } from '@stack/components';
import { EmptyView } from '@stack/components';
import NextLink from 'next/link';

const SignUpScreen = () => {
  // ======================= STATE
  const [success, setSuccess] = useState<boolean>(false);

  // ======================= VIEWS
  const renderField = () => {
    if (success) {
      return (
        <EmptyView
          imgSrc={SuccessLogo.src}
          title={'Congratulations! \n' + 'You’ve signed up to WeSettle'}
          description={
            'We are thrilled to have you on board.\n' +
            'Login to start your journey with us.'
          }
          buttonText={'LOGIN'}
          buttonLink={'/login'}
          titleProps={{
            className: 'text-center whitespace-pre-line',
          }}
          descriptionProps={{
            className: 'text-center whitespace-pre-line',
          }}
          buttonProps={{
            fullWidth: true,
          }}
          // buttonContainerProps={{
          //   style: { width: '100%' },
          // }}
        />
      );
    }
    return <SignUpContainer isSuccess={(value) => setSuccess(value)} />;
  };
  return (
    <Box sx={{ display: 'flex' }}>
      <Box
        sx={{
          display: 'flex',
          width: { xs: '100%', lg: '60%' },
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            mb: 5,
            minWidth: 200,
            maxWidth: 500,
            width: { xs: '90%', lg: '60%' },
            paddingTop: 15,
          }}
        >
          <AuthHeader title={success ? undefined : 'Sign Up'}>
            <>
              {!success && (
                <>
                  <Typography color={'secondary'} variant="subtitle1">
                    Please provide us your personal details
                  </Typography>
                  <Typography color={'secondary'} variant="subtitle1">
                    I already have an account
                    <Link
                      sx={{ ml: 2 }}
                      href={'/login'}
                      variant={'subtitle1'}
                      component={NextLink}
                    >
                      Log in
                    </Link>
                  </Typography>
                </>
              )}
            </>
          </AuthHeader>
          <Box sx={{ mt: 12.5 }}>{renderField()}</Box>
        </Box>
      </Box>
      <SideCover
        pageType={PageType.SIGN_UP}
        noticeList={[
          {
            avatarUrl: '',
            position: 'Finance Manager',
            name: 'Mr Lau',
            description:
              'WeSettle really comes to help during the month end when the company cash flow is tight. I highly recommend their services to all the SMEs in Malaysia.',
          },
          {
            avatarUrl: '',
            position: 'Retail Store Owner',
            name: 'Ahmad Azali',
            description:
              'Friendly user interface and on time payment to my supplier after payment is initiated. Now I can strengthen my relationship with all my suppliers.',
          },
          {
            avatarUrl: '',
            position: 'Cafe Owner',
            name: 'Ms Hemalata',
            description:
              'Easy to sign up and fast approval. Never thought I could earn points and rewards on my credit card by paying my staff monthly salary.',
          },
        ]}
      />
    </Box>
  );
};

export default SignUpScreen;
